import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';
import { EcommerceCategoriaService } from '../services/EcommerceCategoriaService';

const CategoryList = () => {
    const navigate = useNavigate();
    const [categoriesList, setCategoriesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const idEmpresa = 1;

    useEffect(() => {
        const loadCategories = async () => {
            try {
                setError(null);
                const response = await EcommerceCategoriaService.obtenerCategorias(idEmpresa);
                setCategoriesList(response || []);
            } catch (error) {
                setError(`Error cargando categorías: ${error.message}`);
                setCategoriesList([]);
            } finally {
                setLoading(false);
            }
        };

        loadCategories();
    }, []);

    if (loading) {
        return (
            <div className="ec-section">
                <div className="ec-container" style={{ textAlign: 'center', padding: '40px 20px' }}>
                    <ProgressSpinner />
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="ec-section">
                <div className="ec-container">
                    <Message severity="error" text={error} style={{ width: '100%' }} />
                </div>
            </div>
        );
    }

    if (categoriesList.length === 0) {
        return (
            <div className="ec-section">
                <div className="ec-container">
                    <Message severity="info" text="No hay categorías disponibles" style={{ width: '100%' }} />
                </div>
            </div>
        );
    }

    return (
        <div className="ec-section">
            <div className="ec-container">
                <div className="ec-section-header">
                    <h2 className="ec-section-title">
                        Compra por <span>Categorías</span>
                    </h2>
                    <span
                        className="ec-section-link"
                        onClick={() => navigate('/tienda/catalogo')}
                    >
                        Ver todas <i className="pi pi-angle-right"></i>
                    </span>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))',
                    gap: 8
                }}>
                    {categoriesList.map(category => (
                        <div
                            key={category.id}
                            className="ec-category-item ec-animate-fade"
                            onClick={() => navigate(`/tienda/catalogo?cat=${category.id}`)}
                        >
                            <div
                                className="ec-category-icon"
                                style={{
                                    '--hover-bg': category.color || '#2196F3',
                                    '--hover-color': '#fff'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = category.color || '#2196F3';
                                    e.currentTarget.style.color = '#fff';
                                    e.currentTarget.style.borderColor = category.color || '#2196F3';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = 'white';
                                    e.currentTarget.style.color = 'var(--ec-text-secondary)';
                                    e.currentTarget.style.borderColor = 'var(--ec-border)';
                                }}
                            >
                                <i className={category.icon || 'pi pi-list'}></i>
                            </div>
                            <span className="ec-category-name">{category.nombre || category.name || category.descripcion}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CategoryList;
